<mat-expansion-panel class="md-expansion-demo-width" #myPanel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Report Configurations</h6></div>
      <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
        <h6>Site Id: {{ siteId }}</h6>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <br />
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <mat-expansion-panel
        class="md-expansion-demo-width"
        #monthlyPanel
        expanded="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title><h6>Monthly Report</h6></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-table #tableM [dataSource]="monthlyReportConfigs" matSort>
          <ng-container matColumnDef="featureId">
            <mat-header-cell *matHeaderCellDef>Feature ID</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.featureId }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.category }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef>Details</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.description }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="representation">
            <mat-header-cell *matHeaderCellDef>Representation</mat-header-cell>
            <mat-cell *matCellDef="let item">{{
              item.representation
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="enabled">
            <mat-header-cell *matHeaderCellDef>Enabled</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                [(ngModel)]="item.enabled"
                [checked]="item.enabled"
                *ngIf="item.configProp !== 'BaseRO'"
                #showButtons
              ></mat-checkbox>
              <mat-checkbox
                [disabled]="true"
                [checked]="item.enabled"
                *ngIf="item.configProp === 'BaseRO'"
                #showButtons
              ></mat-checkbox>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="monthlyDisplayedColumns"
          ></mat-header-row>
          <mat-row
            *matRowDef="let item; columns: monthlyDisplayedColumns"
          ></mat-row>
        </mat-table>

        <mat-paginator
          #paginatorMonthly
          [pageSize]="5"
          [pageSizeOptions]="[5, 10, 20]"
        >
        </mat-paginator>

        <mat-action-row>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
            <button
              (click)="saveActivationsChanges('M')"
              id="activateMbtn"
              bciprimarybutton
              class="button-primary"
            >
              Save Activations Changes
            </button>
            <button
              (click)="cancel('M')"
              id="deactivateMbtn"
              bciprimarybutton
              class="button-primary"
              style="margin-left: 3px"
            >
              Discard Activations Changes
            </button>

            <button
              (click)="restoreDefault('M')"
              id="restoreMbtn"
              bciprimarybutton
              class="button-primary"
              style="margin-left: 3px"
            >
              Restore Defaults
            </button>
          </div>
        </mat-action-row>
      </mat-expansion-panel>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <mat-expansion-panel
        class="md-expansion-demo-width"
        #dailyPanel
        expanded="true"
      >
        <mat-expansion-panel-header>
          <mat-panel-title><h6>Daily Report</h6></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-table #tableD [dataSource]="dailyReportConfigs" matSort>
          <ng-container matColumnDef="featureId">
            <mat-header-cell *matHeaderCellDef>Feature ID</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.featureId }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.category }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef>Details</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.description }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="representation">
            <mat-header-cell *matHeaderCellDef>Representation</mat-header-cell>
            <mat-cell *matCellDef="let item">{{
              item.representation
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="enabled">
            <mat-header-cell *matHeaderCellDef>Enabled</mat-header-cell>
            <mat-cell *matCellDef="let item">
              <mat-checkbox
                [(ngModel)]="item.enabled"
                [checked]="item.enabled"
                *ngIf="item.configProp !== 'BaseRO'"
                #showButtons
              ></mat-checkbox>
              <mat-checkbox
                [disabled]="true"
                [checked]="item.enabled"
                *ngIf="item.configProp === 'BaseRO'"
                #showButtons
              ></mat-checkbox>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="dailyDisplayedColumns"
          ></mat-header-row>
          <mat-row
            *matRowDef="let item; columns: dailyDisplayedColumns"
          ></mat-row>
        </mat-table>

        <mat-paginator
          #paginatorDaily
          [pageSize]="5"
          [pageSizeOptions]="[5, 10, 20]"
        >
        </mat-paginator>

        <mat-action-row>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
            <button
              (click)="saveActivationsChanges('D')"
              id="activateDbtn"
              bciprimarybutton
              class="button-primary"
            >
              Save Activations Changes
            </button>
            <button
              (click)="cancel('D')"
              id="deactivateDbtn"
              bciprimarybutton
              class="button-primary"
              style="margin-left: 3px"
            >
              Discard Activations Changes
            </button>

            <button
              (click)="restoreDefault('D')"
              id="restoreDbtn"
              bciprimarybutton
              class="button-primary"
              style="margin-left: 3px"
            >
              Restore Defaults
            </button>
          </div>
        </mat-action-row>
      </mat-expansion-panel>
    </div>
  </div>
  <!-- action buttons -->
  <mat-action-row>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
      <button
        (click)="previousStep($event)"
        id="previousbtn"
        bciprimarybutton
        class="button-primary"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Previous
      </button>
      <button
        type="submit"
        id="submitbtn"
        bciprimarybutton
        class="button-primary"
        style="margin-left: 3px"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon> </span
        >Submit
      </button>

      <button
        (click)="nextStep($event)"
        id="nextbtn"
        bciprimarybutton
        class="button-primary"
        style="margin-left: 3px"
      >
        Next
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-arrow-right-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
      </button>
    </div>
  </mat-action-row>
</mat-expansion-panel>
